module.exports = __webpack_public_path__ + "img/againstLogo.59d068b3.svg";